import type { GetStaticProps } from 'next';
import {
  fetchBlogPosts,
  fetchJobPostings,
  fetchPages,
} from '../utils/api/fetchStrapiData';
import CareersPage from '../views/careersPage';

export const getStaticProps: GetStaticProps = async () => {
  const data = await fetchPages();
  const blogPosts = await fetchBlogPosts();
  const jobPosts = await fetchJobPostings();
  return {
    props: { data, blogPosts, jobPosts },
  };
};

export default CareersPage;
